import type { LocationQuery } from "vue-router";

import { agenticAnalytics } from "@/helpers/analytics";
import { getQueryString } from "@/utils/utils";

/** CLI persistent Segment anonymousId — identity stitch key for CLI → dashboard joins. */
export const AGENTIC_ANONYMOUS_ID_QUERY_KEY = "anonymous_id";
/** CLI per-process analytics session id — marks which CLI run opened the dashboard. */
export const AGENTIC_SESSION_ID_QUERY_KEY = "session_id";

export type AgenticAnalyticsCorrelation = {
  anonymousId?: string;
  sessionId?: string;
};

let persisted: AgenticAnalyticsCorrelation = {};

/** Last CLI correlation ids adopted from the login URL (for backend persistence). */
export function getPersistedAgenticCorrelation(): AgenticAnalyticsCorrelation {
  return persisted;
}

/**
 * Drops the in-memory CLI correlation holder. Called on logout so the next
 * user in this browser is not PATCHed with the previous session's
 * anonymous_id (write-once on the user row).
 */
export function clearPersistedAgenticCorrelation(): void {
  persisted = {};
}

export function getAgenticAnalyticsCorrelation(query?: LocationQuery | null): AgenticAnalyticsCorrelation {
  if (!query) return {};
  return {
    anonymousId: getQueryString(query[AGENTIC_ANONYMOUS_ID_QUERY_KEY]),
    sessionId: getQueryString(query[AGENTIC_SESSION_ID_QUERY_KEY]),
  };
}

/** Adopt CLI anonymousId and attach session_id global before agentic dashboard events fire. */
export function applyAgenticAnalyticsCorrelation(query?: LocationQuery | null): void {
  const { anonymousId, sessionId } = getAgenticAnalyticsCorrelation(query);
  persisted = { anonymousId, sessionId };
  if (sessionId) {
    agenticAnalytics.setGlobalProperties({ session_id: sessionId });
  }
  if (anonymousId) {
    agenticAnalytics.setAnonymousId(anonymousId);
  }
}
